import { DateTime } from 'luxon';
import type { IReleaseNote } from './release-notes-sheet-content';

export const RELEASE_NOTES: IReleaseNote[] = [
  {
    date: DateTime.fromISO('2025-06-11'),
    title: '2025-06-11',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Avtalshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrat avtalskapande med datumförslag utifrån det senaste
              avtalet på objektet för att effektivisera skapandeprocessen.
            </li>
          </ul>
        </div>

        <div>
          <h3>Objektshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Bashyra tillagd i objektlistor för bättre ekonomisk översikt.
            </li>
            <li>
              Förbättrade detaljvyer för objekt med ytterligare information
              inklusive anpassade ID:n och hyresvärd-ID:n.
            </li>
            <li>Förbättrad översikt över renoveringar på objektssidor.</li>
          </ul>
        </div>

        <div>
          <h3>Ekonomihantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Åtgärdat problem med förhandsgranskning av fakturor.</li>
            <li>
              Förbättrad hantering av misslyckade avi/fakturaleveranser -
              stängda avier & fakturor döljs nu automatiskt.
            </li>
          </ul>
        </div>

        <div>
          <h3>Rapportförbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Nya rapportalternativ - objektlistor tillagda för omfattande
              fastighetsanalys.
            </li>
            <li>BRF-röstlängd tillagd.</li>
            <li>
              Förbättrad &quot;Välj alla&quot;-funktionalitet för väljare i
              rapporter.
            </li>
            <li>Uppdaterade och förbättrade rapportmallar.</li>
          </ul>
        </div>

        <div>
          <h3>Hyresgäst- och Medlemshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Aktuell registrerad adressinformation tillagd till
              medlemsprofiler.
            </li>
          </ul>
        </div>

        <div>
          <h3>Allmänna Förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrad säkerhet med bättre behörighetskontroller för
              arkivering och ersättningsfunktioner.
            </li>
            <li>Förbättrad filterfunktionalitet över hela plattformen.</li>
            <li>
              Indexeringstaggar tillagda till detaljsidor för bättre översikt.
            </li>
            <li>Förbättrad dashboardprestanda och tillförlitlighet.</li>
            <li>
              Diverse behörighetsrelaterade förbättringar för bättre
              åtkomstkontroll.
            </li>
            <li>Olika säkerhets- och stabilitetsförbättringar.</li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-04-09'),
    title: '2025-04-09',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Notifikationer</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Fixade formateringsproblem med länkar i notisbyggaren vid
              dynamiska värden.
            </li>
          </ul>
        </div>

        <div>
          <h3>Sekretess och Säkerhet</h3>

          <ul className='list-disc space-y-2 text-sm'>
            <li>Förbättrat åtkomstkontroll- och behörighetssystem.</li>
          </ul>
        </div>

        <div>
          <h3>Almmänna Förbättringar</h3>

          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Åtgärdat problem där klick kunde spridas utanför dialogrutor.
            </li>
            <li>Förbättrat beteende vid rensning av åtkomstalternativ.</li>
            <li>Korrigerat sortering av fakturanummer.</li>
            <li>
              Fixat hyresgästrelaterad bugg i Fastighetsägarna Dokument-flödet.
            </li>
            <li>
              Löste problem med statusar som inte synkroniserades korrekt.
            </li>
            <li>Förbättringar av datumväljare.</li>
            <li>Olika prestandaoptimeringar och stabilitetsförbättringar.</li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-03-20'),
    title: '2025-03-20',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Förbättringar av Betalnings- och Fakturahantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Åtgärdat ett problem där påminnelseavgifter kunde skickas ut
              felaktigt efter annullering.
            </li>
            <li>
              Förbättrat hanteringen av förskottsbetalningar och bokföringsdatum
              för att säkerställa korrekt redovisning.
            </li>
            <li>
              Åtgärdat ett problem där betalningar med nollbelopp felaktigt
              skapade bokföringsposter
            </li>
            <li>
              Lagt till möjlighet att styra bokföringsdatum för annullerade
              betalningar, vilket ger bättre flexibilitet i redovisningen
            </li>
          </ul>
        </div>

        <div>
          <h3>Rapportförbättringar</h3>

          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Uppdaterat reskontrarapporten för att visa en mer komplett
              ekonomisk bild.
            </li>
            <li>Lagt till nya kolumner för förseningsavgifter.</li>
            <li>
              Förbättrat visningen av originalbelopp, avgifter och totalbelopp.
            </li>
            <li>Förbättrat tydligheten i beräkningen av kvarstående belopp.</li>
          </ul>
        </div>

        <div>
          <h3>Administrativa Förbättringar</h3>

          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrat tydligheten i meddelanden gällande låsta
              bokföringsperioder.
            </li>
            <li>
              Förbättrat hanteringen av detaljerade loggar för bättre
              systemtransparens.
            </li>
            <li>
              Åtgärdat ett problem med betalningsmatchning där vissa betalningar
              behandlades felaktigt
            </li>
            <li>
              Förbättrat förslag på retroaktiv debitering för att vara mer
              träffsäkra och relevanta
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-05-06'),
    title: '2025-05-06',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Teknisk förvaltning - Ärendehantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Ärendehantering är en ny funktion som gör att du kan skapa,
              hantera och följa upp ärenden.
            </li>
            <li>
              Komponenthantering - Hantera utrymmen och komponenter på objekt
              för att underlätta den tekniska förvaltningen.
            </li>
            <li>
              Automatisk delegering av ärenden till både användare och
              arbetsroller.
            </li>
            <li>
              Möjlighet att skapa, hantera och följa upp ärenden för hyresgäster
              i Mina Sidor.
            </li>
          </ul>
        </div>

        <div>
          <h3>Förbättringar av bokföringshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Bättre översikt över misslyckade synkningar av verifikat, med
              möjlighet att synkronisera igen.
            </li>
            <li>
              Ny översikt över verifikat i bokföringen, med möjlighet att söka
              och filtrera.
            </li>
          </ul>
        </div>
        <div>
          <h3>Nya banker tillagda för E-faktura</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Lunar & Svea bank tillagda som alternativ för E-faktura.</li>
          </ul>
        </div>
        <div>
          <h3>Momsrapport</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Momsrapporten är nu lanserad och tillgänglig under Rapportmodulen.
            </li>
          </ul>
        </div>
        <div>
          <h3>Krediteringshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Adminavgiften inkluderas nu i kreditering av fakturor och avier.
            </li>
          </ul>
        </div>
        <div>
          <h3>Inloggningsförbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrad inloggningshantering för att säkerställa att användare
              kan logga in korrekt med ökad säkerhet.
            </li>
          </ul>
        </div>
        <div>
          <h3>Autogirostatus på avtal</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Åtgärdade problem där statusen på autogiro inte sattes korrekt på
              avtal.
            </li>
          </ul>
        </div>

        <div>
          <h3>Allmänna förbättringar och buggfixar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrad prestanda och stabilitet för att säkerställa att
              användningen är smidig och effektiv.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-05-15'),
    title: '2025-05-15',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Ekonomihantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Ny funktion för massuppdatering av fakturadatum.</li>
            <li>
              Förbättrad betalingsmatchning med stöd för HG-referensnummer.
            </li>
            <li>
              Direkt åtkomst till externa kravdokument från påminnelsesidan.
            </li>
          </ul>
        </div>

        <div>
          <h3>BRF-förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Optimerad prestanda i BRF-översikten med nytt statistiksystem.
            </li>
            <li>Nya funktioner för hantering av inre fonder.</li>
            <li>Förbättrad medlemstabell med uppdaterad periodhantering.</li>
          </ul>
        </div>

        <div>
          <h3>Mobilapp och Notifieringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Förbättrad navigation mellan webb och mobilapp.</li>
            <li>Uppdaterat notifieringssystem med direktlänkar.</li>
            <li>Smidigare inloggning med förbättrad funktionalitet.</li>
          </ul>
        </div>

        <div>
          <h3>Systemförbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Förbättrad felrapportering för integrationer.</li>
            <li>
              Uppdaterade notifieringsinställningar för teknisk administration.
            </li>
            <li>Förbättrad synlighet av signeringsparter i Scrive-loggen.</li>
            <li>Optimerad grupperingsfunktionalitet i kundbalansrapporter.</li>
            <li>Flera säkerhets- och prestandaförbättringar.</li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-06-03'),
    title: '2025-06-03',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Betalningshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Uppdatering av betalningsmatchingsfunktionen med förbättrad
              sökfunktionalitet
            </li>
          </ul>
        </div>

        <div>
          <h3>Fakturahantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Ny uppdelning mellan fakturor och avier i gränssnittet för
              tydligare hantering
            </li>
            <li>
              Verifikationsinställningar för fakturor tillagda i
              bokföringskonfigurationen
            </li>

            <li>Förbättrad periodhantering för fakturor</li>
          </ul>
        </div>

        <div>
          <h3>Sökning och filtrering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Förbättrad sökning och filtrering i tabeller</li>
          </ul>
        </div>

        <div>
          <h3>Buggfixar & förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Åtgärdat diverse buggar och gjort allmänna förbättringar kring
              användarflöden och felhantering
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-06-17'),
    title: '2025-06-17',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Ärendehantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Granskare tillagda i ärendeöversikten för bättre översikt.</li>
          </ul>
        </div>

        <div>
          <h3>Dokumenthantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrat användargränssnitt för huvudsigneringsdokument med
              smidigare hantering.
            </li>
            <li>
              Automatisk rensning av bilagor när huvuddokument raderas för
              bättre datahantering.
            </li>
          </ul>
        </div>

        <div>
          <h3>Ekonomihantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Ny automatisk attesteringsfunktion för påminnelser på enskilda
              avier/fakturor för effektivare arbetsflöden.
            </li>
          </ul>
        </div>

        <div>
          <h3>Kontaktpersoner</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Kontaktpersoner tillagda för bättre hyresgästhantering.</li>
          </ul>
        </div>

        <div>
          <h3>Allmänna Förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrat notifieringssystem med dynamiska URL:er för bättre
              användarupplevelse.
            </li>
            <li>Mindre gränssnittsförbättringar genom hela plattformen.</li>
            <li>
              Diverse buggfixar och stabilitetsförbättringar för smidigare
              användning.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-06-24'),
    title: '2025-06-24',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Ekonomihantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Ny kolumn för antal dagar försenad betalning tillagd i
              avi/faktura-listor för bättre överblick över försenade
              betalningar.
            </li>
            <li>
              Förbättrad hantering av fakturabilagor - bilagor zippas inte
              längre automatiskt vid nedladdning för smidigare
              dokumenthantering.
            </li>
            <li>
              Åtgärdat visningsproblem i översikten för avisering på Övriga
              avtal.
            </li>
          </ul>
        </div>

        <div>
          <h3>BRF-förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Direktlänkar för dokumentnedladdning tillagda för
              BRF-transaktioner för enklare åtkomst till underlag.
            </li>
          </ul>
        </div>

        <div>
          <h3>Teknisk förvaltning</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Chattfunktionen för kommunikation kring ärenden mellan hyresgäster
              och utförare/administratörer är nu lanserad och kan konfigureras i
              konfigcentret.
            </li>
          </ul>
        </div>

        <div>
          <h3>Allmänna Förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrad systemmonitorering för ökad stabilitet och tydligare
              felrapportering.
            </li>
            <li>
              Mindre gränssnittsförbättringar för bättre användarupplevelse.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-07-09'),
    title: '2025-07-09',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Ekonomihantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrad visning av transaktionsmarkeringar med korrekt
              hantering av attesteringsdatum.
            </li>
            <li>
              Åtgärdat problem med PDF-visning och nedladdning av kreditavier
              och fakturor.
            </li>
            <li>
              Förbättrad prestanda vid fakturagenerering med uppdaterad
              cache-hantering.
            </li>
            <li>
              Förenklad momshantering genom att dölja irrelevanta momskonton vid
              dynamisk momsberäkning.
            </li>
            <li>
              Förbättrade referensinställningar för fakturakreditering för
              tydligare hantering.
            </li>
            <li>
              Ny funktion för att välja sidstorlek i lista över misslyckade
              leveranser för bättre översikt.
            </li>
            <li>
              Statistik för misslyckade autogirobetalningar tillagd för bättre
              överblick över betalningsproblem.
            </li>
          </ul>
        </div>

        <div>
          <h3>Dokumenthantering och Signering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Åtgärdat problem med URL-omdirigering för signeringsprocesser från
              dashboarden.
            </li>
            <li>
              E-post satt som standardleveransmetod för signeringsparter för
              smidigare hantering.
            </li>
          </ul>
        </div>

        <div>
          <h3>Rapportförbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Ny rapport för debiteringsrader tillagd för detaljerad ekonomisk
              analys.
            </li>
          </ul>
        </div>

        <div>
          <h3>Objektshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Åtgärdat problem med anpassade fält med långa namn som påverkade
              användargränssnittet.
            </li>
            <li>Förbättrad visning av segment på lokaler i expanderad vy.</li>
            <li>
              Möjlighet att lägga till taggar på renoveringar för bättre
              kategorisering.
            </li>
            <li>Förbättrad visning av adresser i anslutna instanser.</li>
            <li>
              Åtgärdat problem med formulärhantering och felhantering för
              kontaktpersoner.
            </li>
          </ul>
        </div>

        <div>
          <h3>Ärendehantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrad sortering av ärendenamn med uppdaterad standardordning.
            </li>
          </ul>
        </div>

        <div>
          <h3>Avtalshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Åtgärdat problem med uppsägning av blockavtal.</li>
            <li>
              Förbättrad översikt för att se vilka avtal en hyresgäst har.
            </li>
          </ul>
        </div>

        <div>
          <h3>Allmänna Förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrad behörighetshantering med flera korrigeringar och
              förbättringar av signeringsbehörigheter.
            </li>
            <li>Förbättrad länkning från statistik i dashboarden.</li>
            <li>
              Borttagning av små standardsidstorlekar på diverse tabeller för
              bättre användarupplevelse.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-08-20'),
    title: '2025-08-20 - Välkomna tillbaka efter sommaren ☀️',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Avtalshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Nytt förbättrat avtalskapande-flöde för alla objektsbundna
              avtalstyper med förenklad navigation och bättre
              användarupplevelse.
            </li>

            <li>
              Ny funktion för att slå ihop debiteringsrader av samma typ på
              avier.
            </li>
          </ul>
        </div>

        <div>
          <h3>Ekonomihantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förifyllning av betalvillkor på manuella fakturor baserat på
              företagets betalvillkor för effektivare fakturahantering.
            </li>
            <li>
              Fastprisartiklar tillagda för enklare hantering av standardiserade
              priser.
            </li>
            <li>
              Negativa debiteringsrader visas nu i rött för bättre visuell
              överblick av krediteringar.
            </li>
            <li>
              Förbättrad kundreskontra för hyresgäster med omarbetad struktur
              för tydligare ekonomisk översikt.
            </li>
            <li>
              Dimensioner tillagt i fakturaformuläret för enklare hantering.
            </li>
            <li>
              Uppdaterat fakturastatusfilter från &apos;skickad&apos; till
              &apos;öppen&apos; för förtydligad statushantering.
            </li>
          </ul>
        </div>

        <div>
          <h3>Teknisk Förvaltning</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Ärendegrupper för att organisera och hantera relaterade ärenden
              tillsammans.
            </li>
            <li>
              Delegering av ärenden till arbetsroller för bättre arbetsflöden
              och ansvarsfördelning.
            </li>
            <li>
              Utökade ärendekort som visar mer detaljerad information för
              snabbare överblick.
            </li>
            <li>
              Automatisk navigering till ärende efter skapande för smidigare
              arbetsflöde.
            </li>
            <li>
              Rapportkanal tillagd på ärendedetaljsidan för bättre
              kommunikationsspårning.
            </li>
          </ul>
        </div>

        <div>
          <h3>Digital Signering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrat signeringsformulär med avancerade leveransalternativ
              för flexiblare dokumenthantering.
            </li>
            <li>
              Möjlighet att starta om signeringsprocesser för bättre hantering
              av avbrutna signeringar.
            </li>
            <li>Åtgärdat problem med stängning av signeringsdialogfönster.</li>
            <li>
              Korrigerat filter för kontaktpersoner som visas som föreslagna
              parter.
            </li>
          </ul>
        </div>

        <div>
          <h3>Monitorering och Inställningar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättrat konfigurationsflöde för monitorering med nya
              grupperingsalternativ.
            </li>
            <li>
              Massor med nya notismallar för förbättrad kommunikation mot
              hyresgäster.
            </li>
          </ul>
        </div>

        <div>
          <h3>Allmänna Förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Nya filter för &apos;Andrahandsuthyrt&apos; och
              &apos;Borgensman&apos; i dashboard och avtalsöversikter.
            </li>
            <li>
              Förbättrade behörighetshantering med flera korrigeringar för
              säkrare åtkomstkontroll.
            </li>
            <li>
              Diverse gränssnittsförbättringar för bättre användarupplevelse.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-08-28'),
    title: '2025-08-28',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Ärendehantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Möjlighet att visa utskriftsversion av ärende.</li>
            <li>Funktion för att dela länk till ärende via E-post.</li>
            <li>Anpassade fält på allmänna ärenden.</li>
            <li>
              Förtydligande kring personuppgiftshantering i ärendeinställningar.
            </li>
          </ul>
        </div>

        <div>
          <h3>Digital signering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Uppdaterat filter för statusen &quot;Pågående signering&quot;.
            </li>
            <li>Mindre förbättringar i signeringsflöden.</li>
          </ul>
        </div>

        <div>
          <h3>Sökning och filtrering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Stöd för att filtrera på dag i datum-/tidsfält.</li>
            <li>Förenklad filter- och sökhantering i Bjud in hyresgäster.</li>
          </ul>
        </div>
        <div>
          <h3>Rapporter</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Standardmall för &quot;Detaljerad hyresgästlista&quot; uppdaterad.
            </li>
          </ul>
        </div>

        <div>
          <h3>Användarupplevelse</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Förhandsvisning av bild vid uppladdningar.</li>
          </ul>
        </div>

        <div>
          <h3>Leverantörer</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Stöd för externa leverantörer i TF-modulen.</li>
          </ul>
        </div>

        <div>
          <h3>Prestanda och stabilitet</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Formulär optimerade för att undvika onödiga uppdateringar.</li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-09-04'),
    title: '2025-09-04 - Dags för besiktning! 🔍',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Besiktningsmodulen lanserad</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Konfigurera besiktningsinställningar i konfigcentret för att
              anpassa dem till hur er organisation arbetar.
            </li>
            <li>
              Skapa och utför besiktningar för objekt både i webben och i
              TF-Appen.
            </li>
          </ul>
        </div>
        <div>
          <h3>Digital signering med Fastighetsägarna Dokument</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Ny funktion för att sätta upp och nyttja standardmallar med
              Fastighetsägarna Dokument-integrationen.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-09-16'),
    title: '2025-09-16 - Utskicksmodulen lanserad 💌',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Utskick</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Utskicksmodulen är nu lanserad och tillgänglig direkt. Skapa
              utskicksmallar, skicka utskick och hantera målgrupper för att
              effektivisera kommunikationen med hyresgäster.
            </li>
          </ul>
        </div>
        <div>
          <h3>Ekonomihantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Attesterade kreditar kan nu matchas mot avier & fakturor.</li>
            <li>
              Dimensioner föreslås nu på manuellt skapade avier & fakturor, samt
              varnas för vid attestering om obligatoriska dimensioner saknas.
            </li>
          </ul>
        </div>
        <div>
          <h3>Teknisk förvaltning</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Förbättringar och uppdateringar baserat på feedback från testning,
              så som tydligare visning av planerad tid, titlar, översikt av
              kopplingar samt mycket mer.
            </li>
          </ul>
        </div>
        <div>
          <h3>Avtalshantering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Aviseringsinställningar sätts nu upp automatiskt vid skapande av
              avtalsutkast för lägenheter, lokaler, utomhussektioner samt
              fordonsplatser.
            </li>
          </ul>
        </div>
        <div>
          <h3>BRF</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Andelstal stödjer nu 15 decimaler för bättre precision vid
              fördelning av avgifter.
            </li>
          </ul>
        </div>
        <div>
          <h3>Användarupplevelse</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Tabeller i detaljsidor tillåts nu ta upp full bredd på stora
              skärmar, vilket förbättrar översikten.
            </li>
            <li>Förbättrad rullista i formulär med välj alla-funktion.</li>
            <li>Tydligare väljare för matchningsmetod på betalmetoder.</li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-09-24'),
    title: '2025-09-24 - Mallfix och smått & gott 🍬',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Digital signering & digitala mallar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Nya autofyllnadsfält har lagts till i digitala mallar och
              dokument.
            </li>
            <li>
              Förbättrad placering av fält med möjlighet att justera både bredd
              och textstorlek.
            </li>
            <li>
              Nya filter, sorteringar och kolumner i &quot;Mallar&quot; samt
              &quot;Signeringsprocesser&quot; för att förbättra översikten och
              förenkla navigering.
            </li>
            <li>
              Uppdaterade fält i Fastighetsägarna Dokument-mallar, bland annat
              en justering av hur systemet hanterar kryssrutor för &quot;Total
              hyra&quot;.
            </li>
          </ul>
        </div>

        <div>
          <h3>Navigering</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              &quot;Breadcrumbs&quot;-historik tillagt på detaljsidorna för
              enklare navigering.
            </li>
          </ul>
        </div>

        <div>
          <h3>Teknisk förvaltning</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Ärendedelegeringar räknas nu korrekt i totala antalet aviseringar
              under &quot;Inkorg&quot;.
            </li>
            <li>
              Systemet varnar nu om ärende redan har accepterats av en annan
              delegerad part.
            </li>
            <li>
              Allmänna förbättringar över detaljöversikten för ärenden &
              besiktningar.
            </li>
          </ul>
        </div>

        <div>
          <h3>Bas & Hyra</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Debiteringsöversikten för objekt och avtal kan nu ställas in att
              visa årshyra istället för månadshyra.
            </li>
          </ul>
        </div>

        <div>
          <h3>Utskick</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Fler filtreringsmöjligheter tillagda när mottagare ska väljas.
            </li>
            <li>
              Små justeringar och förbättringar baserat på feedback från
              testning.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-09-29'),
    title: '2025-09-29 - Fixar och förbättringar 🔧',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Allmänna fixar och förbättringar </h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Bättre valideringar vid aktivering av integrationer.</li>
            <li>
              Byte av sida på översikten över arbetsroller under
              fastighetsresurser fungerar nu som tänkt.
            </li>
            <li>
              Alla fastigheter kopplade till ett segment syns nu som de ska på
              detaljsidan för segment.
            </li>
            <li>Besiktningar kan nu raderas från detaljsidan.</li>
            <li>
              Landningssidan för dokument skickade via SMS har fått en
              förbättrad design.
            </li>
            <li>
              Transaktions-ID för BRF-transaktioner genereras nu automatiskt
              utifrån objektsnumret på bostadsrätten.
            </li>
            <li>
              Möjlighet att lägga till en egen domän för Mina Sidor har lagts
              till.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-09-30'),
    title: '2025-09-30',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Fastighetsägarna Dokument</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Funktionalitet för att visa mer information om egna mallar skapade
              via Fastighetsägarna Dokument har lagts till. Det går nu att se
              vilka bilagor som finns i mallen samt när den skapades, senast
              uppdaterades, och av vem.
            </li>
            <li>
              Egna mallar skapade via Fastighetsägarna Dokument nyttjar nu den
              utökade autofyllnaden från originalmallen de baserades på, vilket
              leder till att fler fält kan autofyllas ifrån Pigello.
            </li>
          </ul>
        </div>
        <div>
          <h3>Blockavtal</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Blockavtal visas nu under avtalsöversikten på detaljsidan för
              hyresobjekt.
            </li>
          </ul>
        </div>
        <div>
          <h3>Rapporter</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Uppdaterad standardkonfiguration för den detaljerade
              hyresgästlistan.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-10-12'),
    title: '2025-10-12',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Allmänna fixar & förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Sammanställning av debitering under avtal och objekt visar nu
              årshyran som standard, förutom för lägenheter där månadshyran
              visas.
            </li>

            <li>
              Förbättrat redigeringsflöde för avtal, där
              aviseringsinställningarna har flyttat in tillsammans med de
              vanliga avtalsinställningarna för en tydligare översikt.
            </li>

            <li>Utökad funktion för vidaredelegering av ärenden.</li>

            <li>
              Bokföringsverifikat från tidigare system dyker inte längre upp
              under &quot;Misslyckade synkroniseringar&quot;.
            </li>

            <li>
              Manuella aviseringsinställningar och betalvillkorsinställningar
              kan nu användas för att förifylla inställningar för manuella
              fakturor.
            </li>

            <li>
              Leveransmetod hämtas nu från den valda mottagaren automatiskt på
              manuella avier & fakturor.
            </li>

            <li>
              Utskicksmodulen tar nu hänsyn till om hyresgästen är aktiv eller
              inte.
            </li>

            <li>
              Misslyckade leveranser-listan visar nu tydligare status för
              distributionen.
            </li>

            <li>
              Flera förbättringar i gränssnittet för digital signering för att
              underlätta användningen.
            </li>

            <li>
              Samt flera mindre justeringar, optimeringar och förbättringar!
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-10-15'),
    title: '2025-10-15',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Nytt utbildningsmaterial</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Nytt utbildningsmaterial i form av videor tillagda för att hjälpa
              användare att förstå och använda Pigello bättre.
              <br />
              <br />
              <a
                href='https://support.pigello.io/sv/collections/980907-e-learning-utbildningsvideos'
                target='_blank'
                className='text-blue-500 hover:underline'
                rel='noopener noreferrer'
              >
                Klicka här för att komma till utbildningsmaterialet (Extern
                länk)
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3>Utskick</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>Fler filter tillagda för att lättare nå rätt målgrupp.</li>
          </ul>
        </div>
        <div>
          <h3>Arbetsroller</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Optimeringar och förbättringar i flera flöden kopplade till
              arbetsroller när man jobbar med stora datavolymer.
            </li>
          </ul>
        </div>
        <div>
          <h3>Avtals-och objektsstatusar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Uppdaterade benämningar på statusar och filter för objekt och
              avtal för ökad tydlighet.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    date: DateTime.fromISO('2025-10-24'),
    title: '2025-10-24',
    content: (
      <div className='flex flex-col space-y-4'>
        <div>
          <h3>Uppdateringar och förbättringar</h3>
          <ul className='list-disc space-y-2 text-sm'>
            <li>
              Uppdateringar och förtydliganden i formulär och på detaljsida för
              kontaktpersoner
            </li>
            <li>
              Optimeringar och förbättringar av flöden kopplade till
              arbetsroller
            </li>
            <li>
              Tydligare felmeddelanden vid sammanslagning av avier & fakturor,
              det visas nu exakt vad som är anledningen till att det inte går
              att slå ihop dem
            </li>
            <li>
              Bugg som gjorde att avier & fakturor som betalades på
              förfallodatum visades som 1 dag för sent betalade är nu åtgärdad
            </li>
            <li>
              Bugg som gjorde att vissa webbläsare inte kunde avbryta
              signeringsprocesser är nu åtgärdad
            </li>
            <li>Anpassade fält är nu tillgängliga på avier & fakturor</li>

            <li>Dynamisk varibel för status i ärendenotiser tillagd</li>
            <li>Utökad information på detaljsidan för besiktningar</li>
          </ul>
        </div>
      </div>
    ),
  },
];
